// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-15"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 3V9.83333L9 9V21H3V3H13Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 21V11.5L13 9.83333L9 9V21H21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 17V21M13 9.83333V3H3V21H9V9L13 9.83333Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21V11.5L13 9.83333L9 9V21H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const City15Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-15',
    ref,
    icon: element,
  },
));

City15Icon.displayName = 'City15Icon';

export default City15Icon;
